/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {

    declare var processHeaderModel: ProcessHeaderModel;

    export class ProcessHeaderModel {
        public tinyMceOptions: any;
        public processHeaders: Wars.Domain.Model.ProcessHeader[];
        public staticDocuments: Wars.Domain.Model.StaticDocument[];
        public currentTreeItem: models.TreeConfigurationItem;
        public currentProcessHeader:Wars.Domain.Model.ProcessHeader = null;
        public showTinyMce:boolean = false;

        constructor(public processConfigurationId: string,
            private processHeaderService: services.ProcessHeaderService,
            private manageStaticDocumentsService: services.ManageStaticDocumentsService, private treeService: services.TreeService,
            private growlService: angular.growl.IGrowlService, private securityMatrixService: services.SecurityMatrixService) {
            processHeaderModel = this;

            this.processHeaderService.getAllProcessHeaders(processConfigurationId)
                .then(headers => {
                    this.processHeaders = headers;
                });

            manageStaticDocumentsService.getStaticDocumentsForProcessConfiguration(this.processConfigurationId)
                .then(d => {
                    this.staticDocuments = d;
                    this.showTinyMce = true;

                    var images = [];
                    this.staticDocuments.forEach(i => {
                        var image = {
                            title: i.fileName,
                            value: 'api/Document/' + i.id
                        }
                        images.push(image);
                    });

                    this.tinyMceOptions = {
                        format: 'raw',
                        menubar: false,
                        height: 500,
                        plugins: "noneditable, image, preview, code",
                        content_css: "content/mce.css",
                        toolbar1:
                        'insertfield | undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | image | preview | code',
                        relative_urls: false,
                        remove_script_host: false,
                        document_base_url: localStorage.getItem('baseUrl'),
                        image_list: images,
                        external_image_list_url: images,
                        setup: (editor) =>{
                            editor.addButton('insertfield',
                                {
                                    text: 'Insert Field',
                                    icon: false,
                                    onclick: () => {
                                        if (!this.currentTreeItem) {
                                            this.growlService.error('A field must be selected on the tree before you can insert a field.');
                                        } else {
                                            var treeItem = this.treeService.createTreeItemFromConfig(this.currentTreeItem,
                                                () => {
                                                    treeItem.processHeader = this.currentProcessHeader, this.currentProcessHeader.bindings.push(treeItem);
                                                    this.save(() => {
                                                        editor.insertContent("<span class='mceNonEditable fieldBind' data-TreeId=" + treeItem.id + ">" + this.currentTreeItem.text + "</span>");
                                                    });
                                                });
                                        }
                                    }
                                });
                        }
                    };
                });
        }

        public addProcessHeader() {
            let newHeader = this.processHeaderService.createProcessHeader();
            newHeader.name = "New Header";
            newHeader.processConfiguration_id = this.processConfigurationId;
            newHeader.securityMatrix = this.securityMatrixService.createSecurityMatrix(false);
            newHeader.securityMatrix.matrixType = Wars.Domain.Model.Codes.Enums.SecurityMatrixType.HideOrShow;
            this.processHeaders.push(newHeader);
            this.save();

            this.currentProcessHeader = newHeader;
        }

        public getSelectedNode(data: models.TreeConfigurationItem) {
            console.info(data);
            processHeaderModel.currentTreeItem = data;
        }

        public save(callback?) {
            this.processHeaderService.saveAllChanges(callback);
        }

        public manageSecurityMatrix() {
            this.securityMatrixService.openSecurityMatrixModal(this.currentProcessHeader.securityMatrix, this.processConfigurationId);
        }
    }
}